<template>
  <div class="card">
    <div class="card-body">
      <div style="position:relative;">
        <h2>Countries</h2>
        <button type="button" class="btn btn-primary"
          style="position: absolute;right: 0;top: 0;"
          @click="openCreateModal"
        >
          <i class="fa fa-plus"></i> Create
        </button>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fa fa-search"></i>
                </span>
              </div>
              <input class="form-control" placeholder="search countries..." v-model="countryFilter">
            </div>
          </div>
        </div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Currency</th>
            <th scope="col">VAT</th>
            <th scope="col">Import Duties</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="country in filteredCountries">
            <th scope="row">{{ country.name }}</th>
            <td>{{ country.currency }}</td>
            <td>{{ country.vat ? (country.vat) + '%' : '' }}</td>
            <td>{{ country.import_duties ? (country.import_duties) + '%' : '' }}</td>
            <td class="text-right">
              <div class="nowrap">
                <button type="button" class="btn btn-warning btn-sm"
                  @click="openEditModal(country)"
                >
                  <i class="fa fa-edit"></i>
                </button>
                <button type="button" class="btn btn-secondary btn-sm"
                  @click="deleteCountry(country)"
                >
                  <i class="fa fa-trash-alt"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <cu-modal :modalContent="modalContent" v-if="modalContent"
      @countryUpdated="countryUpdated"
      @countryStored="countryStored"
    />
  </div>
</template>

<script>
  import CuModal from './CuModal'
  import { sortByName } from './../../helpers'

  export default {
    props: ['initCountries'],
    components: { CuModal },
    data() {
      return {
        countries: this.initCountries,
        countryFilter: '',
        modalContent: null,
      }
    },
    methods: {
      deleteCountry(country) {
        if (window.confirm(`Do you really want to delete the Country ${country.name}?`)) {
          window.axios.delete(`/countries/${country.id}`).then(({data}) => {
            window.notification.success(`${country.name} has been deleted`, 'Success!')
            const index = this.countries.findIndex(eCountry => eCountry.id === country.id)
            this.countries.splice(index, 1)
          })
        }
      },
      openEditModal(country) {
        this.modalContent = {
          title: `Edit ${country.name}`,
          formClassFields: country,
          submitMethod: 'put',
          submitUrl: `/countries/${country.id}`,
          successEvent: 'countryUpdated',
          submitText: 'Save',
        }
        this.$nextTick(() => $('#cuModal').modal('show'))
      },
      openCreateModal() {
        this.modalContent = {
          title: `Create Country`,
          formClassFields: {
            name: '',
            currency: '',
            vat: '',
            import_duties: '',
          },
          submitMethod: 'post',
          submitUrl: `/countries`,
          successEvent: 'countryStored',
          submitText: 'Create',
        }
        this.$nextTick(() => $('#cuModal').modal('show'))
      },
      countryUpdated(uCountry) {
        window.notification.success(`${uCountry.name} has been updated`, 'Success!')
        const country = this.countries.find(eCountry => eCountry.id === uCountry.id)
        country.name = uCountry.name
        country.vat = uCountry.vat
        country.currency = uCountry.currency
        country.import_duties = uCountry.import_duties
        $('#cuModal').modal('hide')
      },
      countryStored(country) {
        window.notification.success(`${country.name} has been created`, 'Success!')
        this.countries.push(country)
        $('#cuModal').modal('hide')
      },
    },
    computed: {
      filteredCountries() {
        return this.countries.filter(({name}) => name.toLowerCase()
          .indexOf(this.countryFilter.toLowerCase()) > -1
        ).sort(sortByName)
      },
    },
    mounted() {
      $(document).on('hide.bs.modal', '#cuModal', () => this.modalContent = null)
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/countries/CountriesIndex.vue